import ErrorView from 'features/errors/ErrorView';

const NotFoundErrorView = () => (
  <ErrorView code={404} description="Sorry, the page you're looking for is either restricted or deleted." />
);

export default NotFoundErrorView;
